(() => {
  const quizzes = document.querySelectorAll('[data-bw-quiz]');

  quizzes.forEach((quiz) => {
    if (quiz.dataset.initialized === 'true') return;
    quiz.dataset.initialized = 'true';

    const form = quiz.querySelector('[data-quiz-form]');
    const card = quiz.querySelector('[data-quiz-card]');
    const intro = quiz.querySelector('[data-screen="intro"]');
    const loading = quiz.querySelector('[data-screen="loading"]');
    const result = quiz.querySelector('[data-screen="result"]');
    const steps = [...quiz.querySelectorAll('[data-step]')];
    const progressWrap = quiz.querySelector('[data-progress-wrap]');
    const progress = quiz.querySelector('[role="progressbar"]');
    const progressBar = quiz.querySelector('[data-progress-bar]');
    const currentStep = quiz.querySelector('[data-current-step]');
    const totalSteps = quiz.querySelector('[data-total-steps]');
    const error = quiz.querySelector('[data-error]');
    const next = quiz.querySelector('[data-next]');
    const back = quiz.querySelector('[data-back]');
    const cartLink = quiz.querySelector('.bw-quiz__cart');
    let activeIndex = 0;

    totalSteps.textContent = String(steps.length);
    progress.setAttribute('aria-valuemax', String(steps.length));

    document.body.classList.add('bw-quiz-page');
    document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-footer-group').forEach((group) => {
      group.hidden = true;
    });

    cartLink?.setAttribute('aria-haspopup', 'dialog');
    cartLink?.addEventListener('click', (event) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.open !== 'function') return;
      event.preventDefault();
      cartDrawer.open(cartLink);
    });

    const scrollToCard = () => {
      const top = card.getBoundingClientRect().top + window.scrollY - 24;
      window.scrollTo({ top, behavior: 'smooth' });
    };

    const setDogName = () => {
      const value = form.elements.dogName.value.trim();
      const dogName = value || 'your dog';
      quiz.querySelectorAll('[data-dog-name]').forEach((node) => { node.textContent = dogName; });
      return dogName;
    };

    const showStep = (index, shouldScroll = true) => {
      activeIndex = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === activeIndex));
      const count = activeIndex + 1;
      currentStep.textContent = String(count);
      progress.setAttribute('aria-valuenow', String(count));
      progressBar.style.width = `${(count / steps.length) * 100}%`;
      next.textContent = count === steps.length ? 'See my results' : 'Next';
      back.style.visibility = activeIndex === 0 ? 'hidden' : 'visible';
      error.textContent = '';
      if (shouldScroll) scrollToCard();
      const focusTarget = steps[activeIndex].querySelector('input:not([type="hidden"])');
      window.setTimeout(() => focusTarget?.focus({ preventScroll: true }), 220);
    };

    const currentIsValid = () => {
      const step = steps[activeIndex];
      const required = step.querySelector('[required]');
      if (!required) {
        if (step.dataset.step === 'symptoms' || step.dataset.step === 'history') {
          return Boolean(step.querySelector('input:checked'));
        }
        return true;
      }
      if (required.type === 'radio') return Boolean(step.querySelector(`input[name="${required.name}"]:checked`));
      return required.value.trim().length > 0;
    };

    const validationMessage = () => {
      const stepName = steps[activeIndex].dataset.step;
      if (stepName === 'name') return 'Please enter your dog’s name to continue.';
      if (stepName === 'symptoms' || stepName === 'history') return 'Please choose at least one answer.';
      return 'Please choose an answer to continue.';
    };

    const calculateResult = () => {
      const dogName = setDogName();
      const exposure = Number(form.elements.exposure?.value || 0);
      const priority = Number(form.elements.priority?.value || 0);
      const checkedSymptoms = [...form.querySelectorAll('input[name="symptoms"]:checked')];
      const symptoms = checkedSymptoms.filter((input) => input.value !== 'none');
      const symptomScore = symptoms.reduce((sum, input) => sum + Number(input.dataset.score || 0), 0);
      const concern = form.elements.concern?.value || 'prevention';
      const age = form.elements.age?.value || 'adult';
      const score = symptomScore + exposure + priority + (age === 'senior' ? 1 : 0);
      const level = score >= 10 ? 'high' : score >= 5 ? 'moderate' : 'low';
      const badge = quiz.querySelector('[data-result-badge]');
      const copy = quiz.querySelector('[data-result-copy]');
      const reasons = quiz.querySelector('[data-result-reasons]');
      const title = quiz.querySelector('[data-recommendation-title]');
      const recommendationCopy = quiz.querySelector('[data-recommendation-copy]');
      const offerTitle = quiz.querySelector('[data-offer-title]');
      const offerSupply = quiz.querySelector('[data-offer-supply]');
      const offerPrice = quiz.querySelector('[data-offer-price]');
      const offerCompare = quiz.querySelector('[data-offer-compare]');
      const resultCta = quiz.querySelector('[data-result-cta]');
      const size = form.elements.size?.value || 'medium';

      const levelContent = {
        low: {
          badge: 'Lower priority',
          copy: `${dogName} shows fewer of the common lifestyle and symptom patterns associated with ongoing gut stress. A proactive routine and continued observation may be appropriate.`,
          title: 'A proactive wellness routine',
          recommendation: `For a ${size.replace('xl', 'extra-large')} dog, start with the product label guidance and keep a simple weekly record of appetite, stool, skin and energy.`
        },
        moderate: {
          badge: 'Moderate priority',
          copy: `${dogName} shows a combination of exposure and symptom patterns that may justify a more consistent gut and parasite-support routine.`,
          title: 'A consistent 30-day support protocol',
          recommendation: `Use the product label guidance for a ${size.replace('xl', 'extra-large')} dog and track changes in the signs you selected over the full protocol.`
        },
        high: {
          badge: 'Higher priority',
          copy: `${dogName} shows several overlapping patterns that deserve timely attention. Because these signs can have more than one cause, veterinary guidance is especially important if they are severe or persistent.`,
          title: 'Prompt support with careful monitoring',
          recommendation: `Review the protocol for a ${size.replace('xl', 'extra-large')} dog, and speak with your veterinarian about persistent or worsening symptoms before beginning a new routine.`
        }
      }[level];

      const bundleNumber = 2;
      const bundleTitle = quiz.getAttribute(`data-offer-${bundleNumber}-title`) || `${bundleNumber} Bottle${bundleNumber === 1 ? '' : 's'}`;
      const bundlePrice = quiz.getAttribute(`data-offer-${bundleNumber}-price`) || '';
      const bundleCompare = quiz.getAttribute(`data-offer-${bundleNumber}-compare`) || '';
      const supplyLabels = {
        1: 'Recommended starter protocol',
        2: 'Recommended 2-month protocol',
        3: 'Recommended complete protocol'
      };

      const concernLabels = {
        skin: 'Skin, scratching or paw discomfort is the main concern',
        digestive: 'Digestive changes are the main concern',
        behavior: 'Restlessness or behavior changes are the main concern',
        parasite: 'Scooting or parasite exposure is the main concern',
        prevention: 'You are taking a proactive approach'
      };
      const reasonItems = [concernLabels[concern]];
      if (symptoms.length) reasonItems.push(`${symptoms.length} recent sign${symptoms.length === 1 ? '' : 's'} selected`);
      else reasonItems.push('No recent symptoms selected');
      reasonItems.push(exposure >= 2 ? 'Frequent exposure to shared outdoor spaces' : 'Lower exposure to shared outdoor spaces');

      badge.textContent = 'Very necessary';
      badge.dataset.level = level;
      copy.textContent = levelContent.copy;
      title.textContent = 'Why 2 bottles are recommended';
      recommendationCopy.textContent = `${dogName}’s answers indicate a strong parasite concern. An extended 2-month treatment is recommended, which is why the personalized offer includes 2 bottles.`;
      offerTitle.textContent = bundleTitle;
      offerSupply.textContent = supplyLabels[bundleNumber];
      offerPrice.textContent = bundlePrice;
      offerPrice.hidden = !bundlePrice;
      offerCompare.textContent = bundleCompare;
      offerCompare.hidden = !bundleCompare;
      resultCta.textContent = `Get ${dogName}’s offer — checkout`;
      reasons.replaceChildren(...reasonItems.map((reason) => {
        const item = document.createElement('li');
        item.textContent = reason;
        return item;
      }));
    };

    const showResults = () => {
      form.hidden = true;
      progressWrap.hidden = true;
      loading.classList.add('is-active');
      quiz.querySelectorAll('[data-analysis-item]').forEach((item, index) => {
        window.setTimeout(() => item.classList.add('is-complete'), 450 + index * 500);
      });
      scrollToCard();
      window.setTimeout(() => {
        calculateResult();
        loading.classList.remove('is-active');
        result.classList.add('is-active');
        scrollToCard();
      }, 2100);
    };

    quiz.querySelector('[data-start]').addEventListener('click', () => {
      intro.classList.remove('is-active');
      form.hidden = false;
      progressWrap.hidden = false;
      showStep(0);
    });

    next.addEventListener('click', () => {
      if (!currentIsValid()) {
        error.textContent = validationMessage();
        return;
      }
      setDogName();
      if (activeIndex === steps.length - 1) showResults();
      else showStep(activeIndex + 1);
    });

    back.addEventListener('click', () => showStep(activeIndex - 1));

    form.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches('input[type="text"]')) {
        event.preventDefault();
        next.click();
      }
    });

    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', () => {
        const group = [...form.querySelectorAll(`input[name="${input.name}"]`)];
        if (input.dataset.exclusive !== undefined && input.checked) {
          group.filter((item) => item !== input).forEach((item) => { item.checked = false; });
        } else if (input.checked) {
          group.filter((item) => item.dataset.exclusive !== undefined).forEach((item) => { item.checked = false; });
        }
      });
    });

    quiz.querySelector('[data-result-back]').addEventListener('click', () => {
      window.location.href = quiz.dataset.productUrl;
    });
  });
})();
